import router from './router'
import store from './store'
import { Message } from 'element-ui'

const whiteList = ['/login']
router.beforeEach(async(to, from, next) => { //导航守卫  to 将要访问的路径 from 从哪个路径来的，next表示放行
    document.title = to.meta.title;
    const hasToken = store.getters.token;
    if (hasToken) {
        if (to.path === '/login') {
            next({ path: '/' })
        } else {
            const hasRoles = true;
            if (hasRoles) {
                next()
            } else {
                try {
                    const { roles } = await store.dispatch('user/getInfo')
                    const accessRoutes = await store.dispatch('permission/generateRoutes', roles)
                    router.addRoutes(accessRoutes)
                    next({...to, replace: true })
                } catch (error) {
                    await store.dispatch('user/resetToken')
                    Message.error(error || 'Has Error')
                    next(`/login?redirect=${to.path}`)
                }
            }
        }
    } else {
        if (whiteList.indexOf(to.path) !== -1) { //是否在白名单中
            next()
        } else {
            next(`/login?redirect=${to.path}`)
        }
    }
})

router.afterEach(() => {})